export const normaliserModePaiementLocation = (modePaiement) =>
  String(modePaiement ?? '').trim().toLowerCase();

export const estPaiementJournalier = (modePaiement) =>
  normaliserModePaiementLocation(modePaiement) === 'daily';

const normaliserIdLocation = (identifiant) => {
  if (identifiant === null || identifiant === undefined || identifiant === '') {
    return null;
  }
  return String(identifiant);
};

const normaliserDateJournaliere = (valeur) => {
  const resultat = String(valeur ?? '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!resultat) {
    return null;
  }

  const [, annee, mois, jour] = resultat;
  const date = new Date(Number(annee), Number(mois) - 1, Number(jour));
  const dateValide = date.getFullYear() === Number(annee)
    && date.getMonth() === Number(mois) - 1
    && date.getDate() === Number(jour);
  return dateValide ? `${annee}-${mois}-${jour}` : null;
};

const normaliserHeure = (valeur) => {
  const resultat = String(valeur ?? '').match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!resultat) {
    return '99:99:99';
  }

  const heure = Number(resultat[1]);
  const minute = Number(resultat[2]);
  const seconde = Number(resultat[3] || 0);
  if (heure > 23 || minute > 59 || seconde > 59) {
    return '99:99:99';
  }

  return [heure, minute, seconde]
    .map((partie) => String(partie).padStart(2, '0'))
    .join(':');
};

/**
 * Retourne les index dont le tarif journalier doit rester vide.
 * Le tarif métier n'est jamais modifié : seule sa présentation est répartie.
 */
export const obtenirIndicesMontantsJournaliersMasques = (
  lignes = [],
  obtenirInformationsLocation = (ligne) => ligne
) => {
  const candidats = (Array.isArray(lignes) ? lignes : []).flatMap((ligne, index) => {
    const informations = obtenirInformationsLocation(ligne, index) || {};
    const locationId = normaliserIdLocation(informations.mission_rent_id);
    const date = normaliserDateJournaliere(ligne?.date_begin);

    if (!locationId || !date || !estPaiementJournalier(informations.rent_paiement)) {
      return [];
    }

    return [{
      index,
      cle: `${locationId}:${date}`,
      date,
      heure: normaliserHeure(ligne?.heure_begin),
    }];
  });

  candidats.sort((a, b) =>
    a.date.localeCompare(b.date)
    || a.heure.localeCompare(b.heure)
    || a.index - b.index
  );

  const clesComptabilisees = new Set();
  const indicesMasques = new Set();
  candidats.forEach(({ cle, index }) => {
    if (clesComptabilisees.has(cle)) {
      indicesMasques.add(index);
      return;
    }
    clesComptabilisees.add(cle);
  });

  return indicesMasques;
};

